import { ICON__plus } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import i18n_page_generation from '@/locales/keys/i18n_page_generation.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { local_words_set_word_for_adding_related } from '@/state/words/local_words_set_word_for_adding_related_words';
import { FIELD__token } from '@shared/dto/generation/graph_invoke/_fields/token/FIELD__token';
import { useTranslation } from 'react-i18next';

interface Props {
  field: FIELD__token;
}

//button visible only if user received related words
export function G_BUTTON__token_related_words_show({ field }: Props) {
  /*
   * STORE
   */
  const dispatch = use_dispatch();

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_GENERATION);

  /*
   * EVENTS
   */
  function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    dispatch(local_words_set_word_for_adding_related(field.word_english.get_value()));
  }

  /*
   * EFFECTS
   */

  /*
   * HTML
   */

  return (
    <UI_PRIMITIVE__tooltip tooltip_title={t(i18n_page_generation.sidebar_user_input.button.token_add_related_words.tooltip)}>
      <UI_PRIMITIVE__button_with_icon_animated
        variant="no-border-on-component"
        size="rect-10-8"
        {...{ onClick }}
        iconClassNameBase="!text-component-item-foreground size-4"
        iconClassNameHovered="!text-bar-foreground"
        Icon={ICON__plus}
      />
    </UI_PRIMITIVE__tooltip>
  );
}
